import type { DataOrigin } from "@/api";

// 행동 주체(`Dataset.data_origin`) 축의 선택지와 표시 문구를 소유한다. 업로드 설정 폼,
// 상세 Info 카드, 정보 수정 모달이 같은 어휘를 쓴다.
//
// 이 값은 예약 라벨이 아니라 Dataset 컬럼이다. 그래서 reservedLabelConfig 나 datasetFilters 에
// 넣지 않는다. 라벨은 워커 제안과 합쳐지지만, 이 축의 유일한 입력은 업로더 선언이다.

export type DataOriginOption = {
  value: DataOrigin;
  label: string;
  description: string;
};

export const DATA_ORIGIN_OPTIONS: readonly DataOriginOption[] = [
  {
    value: "policy_rollout",
    label: "Policy Inference",
    description: "학습된 Policy 를 실행해 얻은 Inference 데이터입니다.",
  },
  {
    value: "human_demonstration",
    label: "Human demo",
    description: "사람이 만든 시연 데이터입니다.",
  },
];

// 표시 문구로 바꾼다. 미선언(null)이면 null 을 반환한다. 빈 값 표기는 호출부가 정한다.
export function formatDataOrigin(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }
  const option = DATA_ORIGIN_OPTIONS.find((candidate) => candidate.value === value);
  return option ? option.label : value;
}
